<template>
  <div class="edit-instrument instrument-modal-window"
       cy="edit-instrument-modal">

    <h2>
      Editează {{ instrument.type ? ' set' : ' instrument' }}
    </h2>

    <form @submit.prevent="handleSubmit">
      <BaseInput name="name"
                 label="nume:"
                 :value="instrument.name"
                 @input="handleInput" />

      <BaseInput name="id"
                 label="ID:"
                 :value="instrument.id"
                 @input="handleInput" />

      <div v-if="instrument.type === 'set'">
        <label for="">
          <span class="block">
            Instrumente
          </span>
          <select @change="handleAddInstrumentToSet"
                  cy="select-instrument">
            <option value=""
                    selected disabled>
              selectati instrument
            </option>

            <option :value="name"
                    v-for="({ name }, index) in instruments"
                    :key="index">
              {{ name }}
            </option>
          </select>
        </label>

        <ul cy="selected-instruments-list"
            class="selected-instruments">
          <li v-for="(item, index) in instrument.instruments"
              :key="index">
            <span>
              {{ item }}
            </span>
            <button type="button"
                    cy="clear"
                    @click="handleRemoveInstrumentFromSet(item)">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z" fill="white"/>
              </svg>
            </button>
          </li>
        </ul>
      </div>

      <div class="actions-bar flex">
        <button type="button"
                cy="cancel"
                @click="handleCancel">
          Cancel
        </button>

        <button cy="save">
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import BaseInput from "@/components/BaseInput.vue";

  export default {
    name: 'EditInstrument',
    components: { BaseInput },
    props: {
      instruments: Array,
      instrument: Object,
    },
    data () {
      return {
        data: {}
      }
    },
    methods: {
      handleInput ({ name, value }) {
        this.data[name] = value;
      },
      handleSubmit () {
        this.$emit('submit', this.data)
      },
      handleCancel () {
        this.$emit('close')
      },
      handleAddInstrumentToSet (ev) {
        if (!this.data.instruments) {
          this.data.instruments = this.instrument.instruments;
        }
        this.data.instruments.push(ev.target.value);
      },
      handleRemoveInstrumentFromSet (item) {
        if (!this.data.instruments) {
          this.data.instruments = this.instrument.instruments;
        }
        const index = this.data.instruments.findIndex(val => val === item);
        this.data.instruments.splice(index, 1);
      },
    }
  }
</script>

<style lang="less">
  .edit-instrument {
    @media only screen and (min-width: 0) {
      form {
        select {
          width: 100%;
          padding: 6px 10px;
          border: 1px solid #dddddd;
          border-radius: 4px;
          font-size: 1.6rem;
        }
        .selected-instruments {
          font-size: 1.7rem;
          li {
            margin-bottom: 8px;
            button {
              border: none;
              border-radius: 4px;
              background-color: #959595;
              color: white;
            }
          }
        }
      }
    }
  }
</style>
